module.exports = __webpack_public_path__ + "static/media/macbook-pro.e723c891.png";